// import * as FacilitiesActions from './../actions/facilities_actions';
import * as ReasonActions from './../actions/reason_actions'
import extend from 'lodash/extend';

export var Reasons = (state = {
    ReasonDetails: null,
    // ReasonData : []
    ReasonPutResponse: null,
    LogsList: null,
    LogResponse: null,
    HistoryResponse: null
}, action) => {
    console.log(action, 'actiondata')
    switch (action.type) {
        // case "@@redux/INIT": {
        // }

        // case 'success respose':{
        //     return extend({}, state, { ReasonData: action.payload });

        // }

        case ReasonActions.GET_SECURE_REASON: {

            return extend({}, state, { ReasonDetails: action.data });
        }

        case ReasonActions.PUT_SECURE_REASON: {
            return extend({}, state, { ReasonPutResponse: action.data });
        }
        case ReasonActions.LOGS_LIST: {
            return extend({}, state, { LogsList: action.data });
        }
        case ReasonActions.POST_LOG: {
            return extend({}, state, { LogResponse: action.data });
        }
        case ReasonActions.REDFLAGS_HISTORY: {
            return extend({}, state, { HistoryResponse: action.data });
        }
            // case ReasonActions.GET_SECURE_REASON: {

            //     return extend({}, state, { ReasonDetails: action.data });
            // }
            break; default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/reason_reducer.js
 **/